import { Select } from '@lunary/ui-web/select'
import { ACTIVE_DAYS, ROLES, ROLE_LABELS, SOURCES, SOURCE_LABELS } from './labels'
import type { Role, Source } from './labels'

export type UsersFilter = {
  readonly q: string
  readonly role: Role | ''
  readonly source: Source | ''
  readonly activeDays: number | ''
  readonly blocked: 'true' | 'false' | ''
  readonly sort: 'created' | 'last_seen'
}

export const EMPTY_FILTER: UsersFilter = { q: '', role: '', source: '', activeDays: '', blocked: '', sort: 'created' }

type Props = {
  readonly value: UsersFilter
  readonly total: number
  readonly onChange: (next: UsersFilter) => void
}

export function UsersFilters({ value, total, onChange }: Props) {
  const set = (patch: Partial<UsersFilter>) => onChange({ ...value, ...patch })
  return (
    <div className="row" style={{ marginBottom: 16 }}>
      <input
        type="search"
        aria-label="Поиск по email и имени"
        placeholder="Имя, email или @ник"
        value={value.q}
        onChange={(e) => set({ q: e.target.value })}
      />
      <Select
        size="sm"
        sheet="never"
        aria-label="Роль"
        value={value.role}
        options={[{ value: '', label: 'Все роли' }, ...ROLES.map((r) => ({ value: r, label: ROLE_LABELS[r] }))]}
        onChange={(v) => set({ role: ROLES.find((r) => r === v) ?? '' })}
      />
      <Select
        size="sm"
        sheet="never"
        aria-label="Источник"
        value={value.source}
        options={[{ value: '', label: 'Все источники' }, ...SOURCES.map((s) => ({ value: s, label: SOURCE_LABELS[s] }))]}
        onChange={(v) => set({ source: SOURCES.find((s) => s === v) ?? '' })}
      />
      <Select
        size="sm"
        sheet="never"
        aria-label="Активность"
        value={String(value.activeDays)}
        options={[
          { value: '', label: 'Любая активность' },
          ...ACTIVE_DAYS.map((d) => ({ value: String(d), label: d === 1 ? 'Были за сутки' : `Были за ${d} дней` })),
        ]}
        onChange={(v) => set({ activeDays: ACTIVE_DAYS.find((d) => String(d) === v) ?? '' })}
      />
      <Select
        size="sm"
        sheet="never"
        aria-label="Статус"
        value={value.blocked}
        options={[
          { value: '', label: 'Все статусы' },
          { value: 'false', label: 'Активные' },
          { value: 'true', label: 'Заблокированные' },
        ]}
        onChange={(v) => set({ blocked: v === 'true' ? 'true' : v === 'false' ? 'false' : '' })}
      />
      <Select
        size="sm"
        sheet="never"
        aria-label="Сортировка"
        value={value.sort}
        options={[
          { value: 'created', label: 'Сначала новые' },
          { value: 'last_seen', label: 'Недавно заходили' },
        ]}
        onChange={(v) => set({ sort: v === 'last_seen' ? 'last_seen' : 'created' })}
      />
      <span className="muted">Всего: {total}</span>
    </div>
  )
}
